import { forwardRef, useRef } from 'react'
import { Handler } from 'shared/helpers/typeHelper'
import { mergeRefs } from 'shared/helpers/utils'

import { ErrorMessage, Field, HelperMessage, Label, MaskedInput } from './styles'

interface SSNInputProps {
  onChange?: Handler
  value?: string
  label?: string
  placeholder?: string
  name?: string
  type?: string
  error?: React.ReactElement | string | boolean
  helperText?: string
  mask?: string
  backgroundColor?: string
}

export const SSNInput = forwardRef(
  (
    {
      onChange,
      value,
      label,
      placeholder,
      name,
      type = 'text',
      error,
      helperText,
      mask,
      backgroundColor,
    }: SSNInputProps,
    ref
  ) => {
    const ssnField = useRef<HTMLInputElement>(null)
    const hasError = Boolean(error)
    const hasValue = !!value || (typeof value === 'number' && Number(value) === 0)

    function handleFocus() {
      if (name) {
        ssnField?.current?.focus()
      }
    }

    return (
      <Field onClick={handleFocus} $hasError={hasError} $backgroundColor={backgroundColor}>
        <MaskedInput
          inputRef={mergeRefs([ssnField, ref])}
          $backgroundColor={backgroundColor}
          type={type}
          name={name}
          id={name}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          $error={hasError}
          mask={mask || '999 99 9999'}
          data-private="redact"
        />
        <Label htmlFor={name} $active={hasValue}>
          {label}
        </Label>
        {hasError && error !== true && <ErrorMessage>{error}</ErrorMessage>}
        {!hasError && helperText && <HelperMessage>{helperText}</HelperMessage>}
      </Field>
    )
  }
)
